import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledSelect } from '../../../../../shared';

const PreferenceSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control } = useFormContext();

  const preferences = [
    {
      value: 'func',
      label: t('functions')
    },
    {
      value: 'cc',
      label: t('planUnits')
    },
    {
      value: 'cluster',
      label: t('clusters')
    },
    {
      value: 'qual',
      label: t('qualifications')
    },
    {
      value: 'target-group',
      label: t('targetGroups')
    }
  ];

  return (
    <>
      <ControlledSelect
        variant="outlined"
        control={control}
        name="pref_type_list"
        label={t('category')}
        options={preferences}
      />
    </>
  );
};

export default PreferenceSection;
